import React from "react";
import { SonicTermData } from "../../../../common/classes/SonicTerm";
import FormInput from "../../../../common/forms/FormInput";
import SelectMultipleTerms from "../../../../common/forms/SelectMultipleTerms";
import { TermType } from "../../../../utils/useTerm";
import { ValType } from "../../../../utils/ValidationFunctions";
import styles from "../EditBase.module.scss";
import SonicLink from "../../../../common/routing/SonicLink";

interface Props {
  handleInputChange: (value: string | undefined, name: string) => void;
  img_src?: string;
  name?: string;
  kana?: string;
  description?: string;
  color?: string;

  // MyGame
  games?: Array<SonicTermData>;
  handleGames: (value: Array<SonicTermData>) => void;
}

const EditTeamProfile: React.FC<Props> = ({
  handleInputChange,
  img_src,
  name,
  kana,
  description,
  color,
  games,
  handleGames,
}) => {
  return (
    <div className={styles["p-edit__wrapper"]}>
      <div className={styles["p-edit__wrapper__img"]}>
        <div className={styles["p-edit__set-img"]}>
          <div className={styles["p-edit__imgbox"]}>
            <img src={img_src} />
            <div
              className={`${styles["p-edit__form"]} ${styles["p-edit__item-center"]}`}
            >
              <FormInput
                type="file"
                label=""
                label_class={
                  img_src
                    ? styles["p-edit__img__label"]
                    : `${styles["p-edit__img__label"]} ${styles["p-edit__camera-icon"]}`
                }
                id="main_image"
                name="sonic_img"
                style_class={`${styles["image"]} ${styles["p-edit__img__input"]}`}
                handler={handleInputChange}
                val_type={ValType.File}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles["p-edit__inner"]}>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="text"
            label="チーム名/団体名"
            label_class={`${styles["p-edit__form-title"]} ${styles["required-mark"]}`}
            name="sonic_name"
            id="team"
            style_class={styles["p-edit__form-input"]}
            placeholder="チーム名/団体名を入力"
            initial_value={name}
            handler={handleInputChange}
            val_type={ValType.NotNull}
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="text"
            label="チーム/団体(ふりがな)"
            label_class={styles["p-edit__form-title"]}
            name="sonic_kana"
            id="team_kana"
            style_class={styles["p-edit__form-input"]}
            placeholder="チーム名/団体名のふりがなを入力"
            initial_value={kana}
            handler={handleInputChange}
            merit_text={"やり取りがスムーズになります。"}
          />
        </div>
        <div
          className={`${styles["p-edit__form"]} ${styles["p-edit__form-color"]}`}
        >
          <FormInput
            type="color"
            label="チームカラー"
            label_class={styles["p-edit__form-title"]}
            id=""
            name="sonic_color"
            placeholder="#f79b00"
            style_class={`${styles["p-edit__form-input"]} ${styles["color"]}`}
            initial_value={color}
            handler={handleInputChange}
            merit_text={"プロフィールやチーム画面で表示されます。"}
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="textarea"
            label="チーム紹介"
            label_class={styles["p-edit__form-title"]}
            id=""
            name="sonic_description"
            placeholder="チーム紹介"
            style_class={styles["p-edit__form-input"]}
            initial_value={description}
            handler={handleInputChange}
            rows={12}
            merit_text={
              "チームの特徴や長所、成績、実績などアピールしましょう。"
            }
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <div className={styles["p-edit__form-title"]}>ゲーム</div>
          <p>ゲームから検索されやすくなります</p>
          <div className={styles["p-edit__form__current-mygame"]}>
            {games && games.length > 0 ? (
              <div className={styles["p-edit__form__current-mygame-list"]}>
                <p>設定済み</p>
                <ul>
                  {games.map((game, i) => (
                    <li
                      key={i}
                      className={
                        styles["p-edit__form__current-mygame-list-item"]
                      }
                    >
                      {game.name}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div
                className={styles["p-edit__form__current-mygame-list--none"]}
              >
                {"まだゲームが設定されていないようです。"}
              </div>
            )}
          </div>
          <SelectMultipleTerms
            termType={TermType.Games}
            termName="ゲーム"
            buttonText="ゲームを選ぶ"
            terms={games ? games : []}
            handleTerms={handleGames}
          />
          <div className={styles["p-edit__help"]}>
            <SonicLink to="/contact" newTab={true}>
              {"ご希望のゲームがない方はこちら"}
            </SonicLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTeamProfile;
